/* import __COLOCATED_TEMPLATE__ from './article-item-stats.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();